export default __webpack_public_path__ + "2abd275232f5e84d70b94cda1ba20888.png";